import SlideInPanelHandler from './SlideInPanelHandler';

export default SlideInPanelHandler;
